import React from "react";
import { MenuOutlined, UpOutlined } from "@ant-design/icons";
import { Box, BoxProps } from "@mui/material";
import LogoSVG from "src/assets/images/stratosLogo.svg";
import ResponsiveAntMenu from "src/components/ResponsiveAntMenu";
import pageURL from "src/constants/pageURL";
import { useIsMobile } from "src/hooks";
import { NavLink } from "react-router-dom";
import { headerMenu } from "./HeaderMenu";
import {
  GlobalStyle,
  HeaderContainer,
  LogoImageContainer,
  LogoNavContainer,
} from "./StyledComponents";

const Header = ({ sx, ...props }: BoxProps) => {
  const { viewName, isMobile } = useIsMobile();

  return (
    <>
      <GlobalStyle overlayClassName={"not_used_header_overlay"} />
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          padding: "0",
          boxSizing: "border-box",
          backdropFilter: "blur(30px)",
          ...sx,
        }}
        {...props}
      >
        <HeaderContainer className="header_container">
          <LogoNavContainer className="logo_nav_container" $viewName={viewName}>
            <NavLink className="logo_nav_link" to={pageURL.webSite}>
              {() => {
                return (
                  <LogoImageContainer className="logo_image_container">
                    <img
                      alt="icon"
                      src={LogoSVG}
                      style={{ width: "100%", height: "80px" }}
                    />
                  </LogoImageContainer>
                );
              }}
            </NavLink>
          </LogoNavContainer>
          <ResponsiveAntMenu
            // eslint-disable-next-line no-restricted-globals
            activeLinkKey={location.pathname}
            menuClassName="responsive_ant_menu"
            mobileMenuContent={(isMenuShown: boolean) =>
              isMenuShown ? (
                <button className="popover_btn_opened">
                  <UpOutlined />
                </button>
              ) : (
                <button className="popover_btn_closed">
                  <MenuOutlined />
                </button>
              )
            }
          >
            {(onLinkClick: any) => headerMenu(viewName, isMobile, onLinkClick)}
          </ResponsiveAntMenu>
        </HeaderContainer>
      </Box>
    </>
  );
};

export default Header;
